module.exports = "/_next/static/images/logogram-3152fbb3d39120210c4a144f2f232e7e.svg";